import { render } from "./DetailItemModal.vue?vue&type=template&id=38519a9f&scoped=true"
import script from "./DetailItemModal.vue?vue&type=script&lang=js"
export * from "./DetailItemModal.vue?vue&type=script&lang=js"

import "./DetailItemModal.vue?vue&type=style&index=0&id=38519a9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38519a9f"]])

export default __exports__